module.exports = __webpack_public_path__ + "assets/img/service-QRcord-zl.7e3525ec.jpg";